// extracted by mini-css-extract-plugin
module.exports = {"form__textarea":"styles_form__textarea__vWUPc"};